import { createAsyncThunk } from '@reduxjs/toolkit';
import uuidv4 from 'uuid/v4';
import { postCreateSaleInvoiceInstalmentTable } from 'store/saleInvoices/services/postCreateSaleInvoiceInstalmentTable';
import { DEFAULT_INSTALMENT_ALV_PERCENTAGE } from 'store/saleInvoices/utils/instalmentTable';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

const blankRow = () => ({
  id: uuidv4(),
  description: '',
  taxFreeSum: 0,
  alvPercentage: DEFAULT_INSTALMENT_ALV_PERCENTAGE,
  edited: false,
});

// Creates a new instalment table with three blank rows. Row ids are
// client-generated (rows need ids for selection); the table id comes from the
// server.
export const createInstalmentTable = createAsyncThunk(
  'saleInvoices/createInstalmentTable',
  async (_, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    const createdInstalmentTable = await postCreateSaleInvoiceInstalmentTable(
      selectedProjectId,
      {
        taxFreeSum: 0,
        alvPercentage: DEFAULT_INSTALMENT_ALV_PERCENTAGE,
        rows: [blankRow(), blankRow(), blankRow()],
      }
    );

    return createdInstalmentTable;
  }
);
